import { createStore } from 'redux';

export default function (reducers, initialState, enhancer) {
  return createStore(reducers, initialState, enhancer);
}
